import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="cosmic-card p-12 text-center max-w-md w-full">
        <div className="text-8xl font-bold text-gradient mb-6">404</div>
        <h1 className="text-2xl font-semibold mb-4">Page Not Found</h1>
        <p className="text-muted-foreground mb-8">
          Oops! The page you're looking for seems to have vanished into the cosmic void.
        </p>
        
        <div className="space-y-4">
          <Link to="/" className="btn-cosmic w-full inline-flex items-center justify-center">
            <Home className="w-5 h-5 mr-2" />
            Go Home
          </Link>
          
          <Link to="/discover" className="btn-mystery w-full inline-flex items-center justify-center">
            <Search className="w-5 h-5 mr-2" />
            Start Swiping
          </Link>
        </div>
        
        <div className="mt-8">
          <Link to="/" className="inline-flex items-center text-muted-foreground hover:text-foreground transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
